import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const ITEMS = [
    {
        q: "What financial mandates does QuickFin service?",
        a: "Four pillars: private credit for individuals, enterprise capital for SMEs and family businesses, residential mortgage architecture across the Emirates, and strategic venture equity for high-conviction founders. Every mandate is privately structured.",
    },
    {
        q: "How quickly can capital be deployed?",
        a: "Pre-approval is typically returned within 24 hours of a complete file. For private credit and enterprise lines, funds settle in as little as 24 hours after counter-signature. Mortgages follow a 5-day pre-approval and standard regulatory closing.",
    },
    {
        q: "What documents will I need to share?",
        a: "Emirates ID or passport, three to six months of bank statements, proof of income or audited financials, and — where relevant — title deeds or trade licence. Everything is uploaded to our encrypted vault and never shared without consent.",
    },
    {
        q: "Will checking my eligibility affect my credit profile?",
        a: "No. QuickFin uses a soft-bureau methodology for initial eligibility. A formal credit enquiry is only performed once you have reviewed and accepted the indicative term sheet.",
    },
    {
        q: "Can QuickFin restructure or refinance an existing facility?",
        a: "Yes — restructuring and refinancing is a meaningful portion of our private credit and mortgage book. We frequently consolidate multiple facilities into a single, lower-cost structure.",
    },
    {
        q: "Is my data and identity protected?",
        a: "Every QuickFin mandate is bound by a written discretion clause. Data is encrypted in transit and at rest, ring-fenced within UAE jurisdiction, and access-logged.",
    },
];

const FAQ_IMG =
    "https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=900&q=80";

export default function FAQ() {
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="relative py-20 md:py-28 bg-white"
        >
            <div className="max-w-[1280px] mx-auto px-6 md:px-10">
                <div className="grid md:grid-cols-12 gap-8">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3 mb-5">
                            <span className="w-8 h-px bg-gold" />
                            <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">
                                Frequent Enquiries
                            </span>
                        </div>
                        <h2 className="font-serif text-4xl md:text-5xl leading-[1] tracking-tight font-medium text-ink">
                            Your questions,<br />
                            <em className="italic text-gold font-normal">answered.</em>
                        </h2>
                        <p className="mt-5 text-ink-muted font-light text-lg">
                            Still unresolved? Reach an advisor directly — most enquiries are returned the same business day.
                        </p>

                        {/* Image card */}
                        <div className="mt-8 relative aspect-[4/5] max-w-xs overflow-hidden group">
                            <img
                                src={FAQ_IMG}
                                alt="Advisory team"
                                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-forest/90 via-forest/20 to-transparent" />
                            <div className="absolute bottom-4 left-4 right-4">
                                <div className="font-mono text-[9px] uppercase tracking-[0.3em] text-gold mb-1">
                                    Advisory team
                                </div>
                                <div className="font-serif text-xl text-white leading-tight">
                                    Speak with a partner this week.
                                </div>
                                <a
                                    href="#contact"
                                    data-testid="faq-cta"
                                    className="mt-3 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-white hover:text-gold"
                                >
                                    Book a call →
                                </a>
                            </div>
                            <div className="absolute top-0 left-0 right-0 h-1 bg-gold" />
                        </div>
                    </div>

                    <div className="md:col-span-7">
                        <Accordion
                            type="single"
                            collapsible
                            defaultValue="item-0"
                            data-testid="faq-accordion"
                            className="border-t border-cream-deep"
                        >
                            {ITEMS.map((it, i) => (
                                <AccordionItem
                                    key={i}
                                    value={`item-${i}`}
                                    data-testid={`faq-item-${i}`}
                                    className="border-b border-cream-deep"
                                >
                                    <AccordionTrigger className="text-left hover:no-underline py-6 group">
                                        <div className="flex items-start gap-5 w-full">
                                            <span className="font-mono text-[10px] tracking-[0.3em] text-gold mt-1 shrink-0">
                                                0{i + 1}
                                            </span>
                                            <span className="font-serif text-xl md:text-2xl text-ink group-hover:text-gold transition-colors leading-tight">
                                                {it.q}
                                            </span>
                                        </div>
                                    </AccordionTrigger>
                                    <AccordionContent className="text-ink-muted font-light leading-relaxed pl-10 pb-6 text-base">
                                        {it.a}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
        </section>
    );
}
